export default document.body.classList.contains('is-editmode');